var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#54CC90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2469 4.27117C12.7018 4.82483 12.4917 5.29283 12.18 5.70749L6.22177 11.9504C6.06775 12.1553 5.8546 12.2712 5.63177 12.2712C5.40895 12.2712 5.1958 12.1553 5.04178 11.9504L2.62026 9.2075C2.30858 8.79284 2.04072 8.33029 2.5 7.77118C2.81183 7.39156 3.48857 7.35652 3.80025 7.77118L5.63177 9.72911L11 4.27117C11.3117 3.85651 11.997 3.96689 12.2469 4.27117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreen);
export default __webpack_public_path__ + "static/media/success-green.f98920cee3f6d7309b3fd3aaa34b32dd.svg";
export { ForwardRef as ReactComponent };